import Spinner from './Spinner';
import SpinnerCircle from './SpinnerCircle';

export { Spinner, SpinnerCircle };
